import { gql } from 'urql'

export const ALLOW_ALL_IP = '0.0.0.0'

export const ROLE_LABELS = {
  ADMIN: 'Admin',
  COLABORADOR: 'Colaborador',
  SUPER_COLABORADOR: 'Super Colaborador',
  DPO: 'DPO',
}

export const formatRoleLabel = (role) => ROLE_LABELS[role] || role

export const formatAllowedIp = (ip) => {
  if (!ip || ip === ALLOW_ALL_IP) return 'Todas las IPs (0.0.0.0)'
  return ip
}

export const entryIp = (item) => (typeof item === 'string' ? item : item?.ip || '')

export const entryDescription = (item) => (
  typeof item === 'string' ? '' : String(item?.description || '').trim()
)

export const isUnrestrictedIps = (entries) => {
  const list = Array.isArray(entries) ? entries : []
  return list.length === 0 || list.every((item) => {
    const ip = entryIp(item)
    return !ip || ip === ALLOW_ALL_IP
  })
}

export const entriesFromRow = (row) => {
  if (Array.isArray(row?.allowedIps) && row.allowedIps.length) {
    return row.allowedIps
      .map((item) => ({ ip: entryIp(item), description: entryDescription(item) }))
      .filter((item) => item.ip)
  }
  if (row?.allowedIp) return [{ ip: row.allowedIp, description: '' }]
  return [{ ip: ALLOW_ALL_IP, description: '' }]
}

const FIELDS = `
  id
  role
  allowedIp
  allowedIps {
    ip
    description
  }
  updatedBy
  updatedAt
`

export const GET_ROLE_IP_WHITELISTS = gql`
  query RoleIpWhitelists {
    roleIpWhitelists {
      ${FIELDS}
    }
  }
`

export const UPDATE_ROLE_IP_WHITELIST = gql`
  mutation UpdateRoleIpWhitelist($input: UpdateRoleIpWhitelistInput!) {
    updateRoleIpWhitelist(input: $input) {
      ${FIELDS}
    }
  }
`
